module.exports = __webpack_public_path__ + "img/img_view_direct_skt_03.18f36abe.png";